export default __webpack_public_path__ + "static/media/bronze_outlined.8360a679.svg";